import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../images/laundry-care-logo.png';
import { useAuth } from '../context/AuthContext';
import { API } from '../api/axios';

const STRAPI_URL = import.meta.env.VITE_STRAPI_URL || 'http://localhost:1337';

function Signin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [errors, setErrors] = React.useState({});
  //if there is an email parameter in the URL, set it as the email state
  React.useEffect(() => {
    localStorage.removeItem('token');
    const urlParams = new URLSearchParams(window.location.search);
    const emailParam = urlParams.get('email');
    if (emailParam) {
      setEmail(emailParam);
    }
  }, []);
  const validate = () => {
    const newErrors = {};
    if (!email) {
      newErrors.email = 'Email is required';
    } else if (!/^[\w.+-]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      newErrors.email = 'Invalid email address';
    }
    if (!password) {
      newErrors.password = 'Password is required';
    } else if (password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const googleLogin = () => {
    window.location.href = `${STRAPI_URL}/api/connect/google`;
  };

  const loginWithEmail = async (email, password) => {
    if (!validate()) return;
    try {
      const res = await API.post('/auth/local', {
        identifier: email,
        password,
      });
      if (res.status === 200 && res.data.jwt) {
        login(res.data.jwt, res.data.user);
        navigate('/');
      } else {
        alert('Login failed or token missing');
        navigate('/signin');
      }
      return res.data;
    } catch (err) {
      alert('Login failed');
    }
  };

  return (
    <main className="bg-white  ">
      <div className="flex items-center justify-center min-h-screen bg-blue-50">
        <div className="flex flex-col after:flex-1">
          <div className="flex items-center justify-center h-16 px-4 mb-4 sm:mb-20 sm:px-6 lg:px-8">
            <Link className="block" to="/">
              <img className="w-80" src={logo} alt="Laundry Care" />
            </Link>
          </div>
          <div className="max-w-lg mx-auto align-middle">
            <div className="text-center">
              <p className="text-blue-500 text-2xl font-semibold my-1">
                Log In
              </p>
              <p className="text-portal-400 mb-5">
                Welcome back! Please enter your details.
              </p>
            </div>
            <div className=" px-8 sm:px-10 py-8 sm:py-10 mx-5 sm:mx-1 shadow-2xl border border-slate-200 rounded-lg bg-white">
              <div className="space-y-6">
                <div>
                  <label className="block  font-medium mb-1" htmlFor="email">
                    Email
                  </label>
                  <input
                    id="email"
                    className="form-input w-full bg-slate-50 border-0 rounded-lg"
                    type="email"
                    autoComplete="on"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    required
                    autoFocus
                    placeholder="example@gmail.com"
                  />
                  {errors.email && (
                    <p className="text-red-500 text-sm mt-1">{errors.email}</p>
                  )}
                </div>
                <div>
                  <label className="block  font-medium mb-1" htmlFor="password">
                    Password
                  </label>
                  <input
                    id="password"
                    className="form-input w-full bg-slate-50 border-0 rounded-lg"
                    type="password"
                    onChange={(e) => setPassword(e.target.value)}
                    value={password}
                    required
                    placeholder="********"
                    autoComplete="on"
                  />
                  {errors.password && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.password}
                    </p>
                  )}
                </div>
              </div>
              <div className="flex flex-row-reverse mt-3">
                <div className="mr-1">
                  <Link
                    className="text-md font-semibold hover:no-underline text-blue-500 "
                    to="/#">
                    Forgot Password?
                  </Link>
                </div>
              </div>
              <div className="flex flex-wrap my-5">
                <div className="w-full">
                  <button
                    className="btn py-2.5 text-md font-semibold text-white bg-blue-500 hover:bg-blue-700 w-full rounded-full"
                    type="button"
                    onClick={() => loginWithEmail(email, password)}>
                    Login
                  </button>
                </div>
              </div>
              <div className="flex flex-wrap my-5">
                <div className="w-full">
                  <button
                    type="button"
                    onClick={() => googleLogin()}
                    className="btn py-2.5 text-md font-semibold text-sky-900 bg-white hover:bg-grey-100 w-full relative flex items-center rounded-full border border-slate-100">
                    <svg
                      className="w-4 h-4 fill-current text-red-600 opacity-75 shrink-0 mx-4"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.9 7v2.4H12c-.2 1-1.2 3-4 3-2.4 0-4.3-2-4.3-4.4 0-2.4 2-4.4 4.3-4.4 1.4 0 2.3.6 2.8 1.1l1.9-1.8C11.5 1.7 9.9 1 8 1 4.1 1 1 4.1 1 8s3.1 7 7 7c4 0 6.7-2.8 6.7-6.8 0-.5 0-.8-.1-1.2H7.9z" />
                    </svg>
                    <span className="flex-auto pl-16 pr-8 -ml-16">
                      Login with Google
                    </span>
                  </button>
                </div>
              </div>
              <div className="pt-5 mt-6 flex justify-center">
                <div className="text-md">
                  Don’t have an account?{' '}
                  <Link
                    className="font-semibold text-blue-500 hover:text-blue-800"
                    to="/register">
                    Create an account.
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Signin;
